import type { Editor } from '@tiptap/react';
import { useTiptapEditor } from '@examdojo/core/tiptap-react-ui-components/hooks/use-tiptap-editor';
import { isNodeTypeSelected } from '@examdojo/core/tiptap-react-ui-components/lib/tiptap-utils';
import { DeleteNodeButton } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/delete-node-button';
import { ImageDownloadButton } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/image-download-button';
import { ImageAlignButton } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/image-align-button';
import { Separator } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui-primitive/separator';
import { ImageCaptionButton } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/image-caption-button';
import { ImageUploadButton } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui/image-upload-button';
import { RefreshCcwIcon } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-icons/refresh-ccw-icon';

export function ImageNodeFloating({ editor: providedEditor }: { editor?: Editor | null }) {
  const { editor } = useTiptapEditor(providedEditor);
  const visible = isNodeTypeSelected(editor, ['image']);

  if (!editor || !visible) {
    return null;
  }

  return (
    <>
      <ImageAlignButton align="left" />
      <ImageAlignButton align="center" />
      <ImageAlignButton align="right" />
      <Separator />
      <ImageCaptionButton />
      <Separator />
      <ImageDownloadButton />
      <ImageUploadButton icon={RefreshCcwIcon} tooltip="Replace" />
      <Separator />
      <DeleteNodeButton />
    </>
  );
}
